import React from 'react';
import clsx from 'clsx';

import Td from '../../../../../../components/common-table/components/Td';
import { URL_STATUSES } from '../../../../../../constants';
import CommonTooltip from '../../../../../../components/common-tooltip/CommonTooltip';

import scss from './CollectDataTable.module.scss';

const MediaCell = ({ links }) => {
  return (
    <Td extraClasses={scss.mediaCell} isLeft>
      {(links || []).map(({ url, status }) => (
        <CommonTooltip key={url} title={url}>
          <span
            className={clsx(
              scss.mediaCellCircle,
              status === URL_STATUSES.SUCCESS ? scss.mediaCellGreen : scss.mediaCellRed,
            )}
          />
        </CommonTooltip>
      ))}
    </Td>
  );
};

export default MediaCell;
